export default __webpack_public_path__ + "static/SRUS P340 - Especification Del Producto y Datos Técnicos-cba148437fbeb01ddb9c5a80ead76f52.pdf";